import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { isMobileWidth } from "../../app/utils";
import Bowser from "bowser";
import { useAppSelector } from "../../app/hooks";

export interface PageWidthState
{
    isMobile: boolean;
}

const initialPageWidthState: PageWidthState = {
    isMobile: isMobileWidth( window.innerWidth ),
};

export const pageWidthSlice = createSlice( {
    name: "mobile",
    initialState: initialPageWidthState,
    reducers: {
        setPageWidth( state, action: PayloadAction<number> )
        {
            const parser = Bowser.getParser( navigator.userAgent );
            state.isMobile = isMobileWidth( action.payload ) || parser.getPlatformType().toLowerCase() === "mobile";
        },
    },
} );

// Selector to get mobile state
export const selectIsMobile = ( state: RootState ) => state.pageWidth.isMobile;

export const useIsMobile = () => useAppSelector( selectIsMobile );
export const { setPageWidth } = pageWidthSlice.actions;
export default pageWidthSlice.reducer;
